import {AfterViewInit, Component, Inject, Input, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup} from "@angular/forms";
import {NgxMatDatetimepicker} from "@angular-material-components/datetime-picker";
import CalendarService from "../../../api/calendar/calendar.service";
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from "@angular/material/dialog";
import VacationModel from "../../../model/vacation.model";

@Component({
  selector: 'app-vacation',
  templateUrl: './vacation.component.html',
  styleUrls: ['./vacation.component.scss']
})
export class VacationComponent implements OnInit, AfterViewInit{
@Input() event: VacationModel;
public eventForm: FormGroup;

@ViewChild(NgxMatDatetimepicker) picker: NgxMatDatetimepicker<any>;
  constructor(private calendarService: CalendarService, private fb: FormBuilder,
      public dialogRef: MatDialogRef<VacationComponent>,
      private dialog: MatDialog,
  @Inject(MAT_DIALOG_DATA) public data: VacationFormDialogModel) { }

  ngAfterViewInit(): void {
  }

  ngOnInit(): void {
    this.event = this.data.event;
    this.eventForm = this.fb.group({
      destination: [this.event.destination],
      fromDate: [this.event.fromDate],
      toDate: [this.event.toDate],
    });
  }

  save() {
    const data = this.eventForm.getRawValue() as VacationModel;

    if(this.event?.id) {
      data['id'] = this.event.id;
    }
    this.calendarService.createVacation(data).subscribe(result => {
      if(result) {
        this.dialogRef.close(result);
      }
    });
  }
}
export class VacationFormDialogModel {
  constructor(public event: VacationModel) {
  }
}
